import React, { useCallback } from 'react';

import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Box, Button, Modal, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { useGetCurrentBreakpoint, useHideScroll, useIsVisibleModal, useModal } from '@hooks';
import { ExclamationIcon } from '@themes';

export const GenericErrorModal: React.FC = () => {
	const t = useTranslation();
	const { hide } = useModal('genericError');
	const { currentView } = useGetCurrentBreakpoint();
	const { enable } = useHideScroll();
	const isVisible = useIsVisibleModal('genericError');

	const handleOnClickClose = useCallback(() => {
		enable();
		hide();
	}, [enable, hide]);

	return (
		<Modal
			lockScroll={false}
			animated
			visible={isVisible}
			onHide={handleOnClickClose}
			children={
				<Box
					styles={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
						gap: '32px',
						backgroundColor: 'white',
						borderRadius: '24px',
						margin: '0 16px 0',
						padding: '64px 16px 48px',
					}}
				>
					<Box
						styles={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							width: '100%',
							textAlign: 'center',
							gap: currentView === 'smallView' ? '24px' : '32px',
							padding: currentView === 'bigView' ? '0 24px' : '',
						}}
					>
						<ExclamationIcon />
						<Box
							styles={{
								flexDirection: 'column',
								alignItems: 'center',
								width: '100%',
								gap: '16px',
							}}
						>
							<Typography colorToken="primary-light" appearance="subtitle-100-04">
								{t('simulator.modals.genericError.title')}
							</Typography>
							<Typography colorToken="primary-light" appearance="body-100-02">
								{t('simulator.modals.genericError.pleaseTryAgain')}
							</Typography>
						</Box>
						<Box
							styles={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
								width: currentView === 'smallView' ? undefined : '50%',
								gap: currentView === 'smallView' ? '16px' : '',
							}}
						>
							<Button size="large" fixedWidth={true} onPress={handleOnClickClose}>
								{t('simulator.modals.genericError.exit')}
							</Button>
						</Box>
					</Box>
				</Box>
			}
		/>
	);
};
